<template lang="pug">
div
  el-form-item(label="最大高度")
    el-input-number(v-model="maxHeight", :precision="0", :min="0")
  el-form-item(label="详情编号")
    el-select(v-model="contentKey", filterable)
      el-option(v-for="{ contentKey, label } in list", :value="contentKey", :key="contentKey", :label="label")
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { pub_rich_content_list } from "@/CommonDP/service/rich-text-service";
export default {
  mixins: [settingMixin],
  data() {
    return { list: [] };
  },
  computed: {
    ...mapVFOptions("maxHeight", "contentKey")
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { data } = await pub_rich_content_list({ pageNum: 1, pageSize: 99999 });
      this.list = data;
    }
  }
};
</script>
